<template>
  <div id="app" class="h-100" :class="[skinClasses]" ref="refApp">
    <component :is="layout">
      <router-view />
    </component>
    <scroll-to-top v-if="enableScrollToTop" />
    <actions-fixed v-if="is_loggin" :actions-items="actionsItems" />
    <chat v-if="is_loggin" v-model="showChat" />
    <!-- <entrevista-global v-if="is_loggin && entrevista_global_id" v-model="showEntrevistaGlobal"
      :entrevista-global="entrevista_global_id" :es-regalo="es_regalo" /> -->

    <dialog-form-configurar v-if="is_loggin && isCliente" v-model="showFormConfig" />
    <drawer-compra-paginas v-if="is_loggin" v-model="showFormCompraPaginas" />
    <drawer-ayuda v-if="is_loggin" v-model="showApoyo" :actions="useVideoApoyo" />
    <drawer-perfil-publico :slug="slug_autor" v-model="showPerfilPublico" />
    <chat-component v-model="showChatComponent" :modelo="modelo" :modelo-id="modelo_id" />
    <chat-contact :show="showChatContact" :contacto="contacto" />
    <WelcomeGuia v-if="is_loggin && isCliente" />
    <TourManager />

  </div>
</template>

<script setup>

import ScrollToTop from '@/components/scroll-to-top/ScrollToTop.vue'
import ActionsFixed from 'components/ActionsFixed.vue';
import TourManager from '@/components/TourManager.vue';
import EntrevistaGlobal from 'components/EntrevistaGlobal.vue';
import WelcomeGuia from 'components/WelcomeGuia.vue';
import { useIdle, useCounter } from '@vueuse/core'
import drawerCompraPaginas from 'components/drawerCompraPaginas.vue';
import DialogFormConfigurar from 'views/biografias/DialogFormConfigurar.vue';
import { $themeColors, $themeBreakpoints, $themeConfig } from '@themeConfig'
import ChatComponent from 'views/chats/ChatComponent.vue';
import useAppConfig from '@/app-config/useAppConfig'
import useVideoApoyo from 'views/biografias/useVideoApoyo';
import DrawerAyuda from 'components/DrawerAyuda.vue';
import DrawerPerfilPublico from 'components/DrawerPerfilPublico.vue';
import ChatContact from 'views/chats/ChatContact.vue';
import useChat from '@composables/useChat.js';

import useAuth from '@utils/useAuth.js';
import useUsuarioStore from '@/store/usuario';
import useAppConfigStore from '@/store/app-config'
import useAppStore from '@/store/app';
import useRootStore from '@/store/root';
import useUtils from '@composables/useUtils';

import useSistemaStore from '@/store/sistema';
import useVerticalLayout from '@layouts/layout-vertical/useVerticalLayout.js';
import LayoutVertical from '@layouts/vertical/LayoutVertical.vue'
import LayoutFull from '@layouts/full/LayoutFull.vue'
import chat from 'views/chats/chat.vue';
import { useRegisterSW } from '@/composables/useRegisterSW'
import { ElNotification } from 'element-plus';
const sistema_store = useSistemaStore();
const usuario_store = useUsuarioStore();
const app_config_store = useAppConfigStore();
const app_store = useAppStore();
const root_store = useRootStore();
const { is_loggin, montarEchoApp, logout, cerrarSesionAutomatica } = useAuth();

const { cargarUser, welcome_guia } = usuario_store;


const isCliente = computed(() => usuario_store.isCliente);
const showEntrevistaGlobal = ref(false);
const showFormConfig = ref(false);
const slug_autor = ref('');
const showPerfilPublico = ref(false);
const es_regalo = ref(false);

const entrevista_global_id = ref(null);
const showFormCompraPaginas = ref(false);
const showApoyo = ref(false);
const showChatComponent = ref(false);
const modelo = ref(null);
const modelo_id = ref(null);


const { inc, count } = useCounter();
const { idle, lastActive, reset } = useIdle(5 * 60 * 1000) // 5 minutos de inactividad, si el usuario no ha usado el sistema y no pidió ser recordado, se cierra la sesión automáticamente


const {
  anchoSidebar
} = useUtils();

const actions_chat = useChat();
const {
  show: showChatContact,
  contacto,
} = actions_chat;


provide('showPerfilPublico', showPerfilPublico);
provide('slug_autor', slug_autor);
provide('showEntrevistaGlobal', showEntrevistaGlobal);
provide('entrevista_global_id', entrevista_global_id);
provide('showFormConfig', showFormConfig);
provide('showFormCompraPaginas', showFormCompraPaginas);
provide('showApoyo', showApoyo);
provide('showChatComponent', showChatComponent);
provide('modelo', modelo);
provide('modelo_id', modelo_id);
provide('es_regalo', es_regalo);
provide('actions_chat', actions_chat);

const notificationReload = (title, msj = '', duration = 10) => {
  ElNotification({
    title: title,
    message: h('strong', { class: 'text-nowrap' }, msj),
    type: 'info',
    position: 'bottom-right',
    duration: duration > 0 ? duration * 1000 : 0
  });
};


const {
  offlineReady,
  needRefresh,
  updateServiceWorker,
} = useRegisterSW();

watch([offlineReady, needRefresh], () => {
  if (offlineReady.value) {
    // notificationReload('Service Worker', 'El Service Worker de la plataforma ya está cargado.');
  }

  if (needRefresh.value) {
    notificationReload('Nueva versión', 'Tienes una nueva versión de esta aplicación, Recargaremos en 3 segundos', 3);
    updateServiceWorker();
  }
});


watch(idle, (v) => {
  if (v) {
    inc();
    if (count.value >= 1 && is_loggin.value) {
      cerrarSesionAutomatica().then(({ recordado }) => {
        if (recordado) {
          reset();
          count.value = 0;
        } else {
          logout();
          reset();
          count.value = 0;
          toast.error("Has sido desconectado por inactividad, por favor inicia sesión nuevamente");
        };

      }).catch(e => {
        logout();
      })
    }
    reset();
  }
})



const mostrarEntrevistaGlobal = (entr_id) => {
  entrevista_global_id.value = entr_id;
  if (entrevista_global_id.value) {
    showEntrevistaGlobal.value = true;
  }
}

const mostrarWelcomeGuia = () => {
  showWelcomeGuia.value = true;
}

provide('mostrarEntrevistaGlobal', mostrarEntrevistaGlobal);
provide('mostrarWelcomeGuia', mostrarWelcomeGuia);

const montarThema = () => {
  //   // Set colors in theme
  const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark']

  // eslint-disable-next-line no-plusplus

  for (let i = 0, len = colors.length; i < len; i++) {
    $themeColors[colors[i]] = useCssVar(`--bs-${colors[i]}`, document.documentElement).value?.trim() ?? null
  }

  // Set Theme Breakpoints
  const breakpoints = ['sm', 'md', 'lg', 'xl', 'xxl']

  // eslint-disable-next-line no-plusplus
  for (let i = 0, len = breakpoints.length; i < len; i++) {
    $themeBreakpoints[breakpoints[i]] = Number(useCssVar(`--bs-breakpoint-${breakpoints[i]}`, document.documentElement).value.slice(0, -2))
  }

};

montarThema();



const route = useRoute();
const { usuario, usuario_id } = storeToRefs(usuario_store);
const contentLayoutType = computed(() => app_config_store.layout.type)

const layout = computed(() => {
  if (route.meta.layout === 'full') return LayoutFull;
  return LayoutVertical;
});


const { skin, skinClasses } = useAppConfig();
const { enableScrollToTop } = $themeConfig.layout
const { isOnline } = useNetwork();


// // If skin is dark when initialized => Add class to body
if (skin.value === 'dark') document.body.classList.add('dark-layout')

// // Set Window Width in store

app_store.UPDATE_WINDOW_WIDTH(window.innerWidth);
const { width: windowWidth } = useWindowSize()

watch(windowWidth, (val) => app_store.UPDATE_WINDOW_WIDTH(val));



watch(isOnline, (val) => {

  if (!val) {
    toast.info("La conexíón ha caido, informalo a tú operadora")
  }

});

const refApp = ref(null)
const showChat = ref(false);

const toggleChat = () => showChat.value = !showChat.value;

const actionsItems = ref([
  { icon: 'fab fa-rocketchat', title: "Chat", action: toggleChat },
]);

const { toggleVerticalMenuActive } = useVerticalLayout();

const { isSwiping, direction, coordsStart, coordsEnd } = useSwipe(refApp, {
  passive: true,
  disableTextSelect: true
});

provide('isSwiping', isSwiping)
provide('directionSwiping', direction)
provide('coordsStart', coordsStart)
provide('coordsEnd', coordsEnd)



provide('montarEchoApp', montarEchoApp);

const montarEchoPublic = () => {

  Echo.channel('public')
    .listen('.usuario.conectado', ({ usuario_id, datos }) => {
      usuario_store.conectarUsuario(usuario_id, datos);
    })
    .listen('.usuario.desconectado', ({ usuario_id }) => {
      usuario_store.desconectarUsuario(usuario_id);
    });

}

onMounted(() => {
  montarEchoPublic();
  if (localStorage.getItem('token')) {
    cargarUser(JSON.parse(localStorage.getItem('userData')));
    sistema_store.fetch()
    montarEchoApp();
    usuario_store.refetchUsuario(usuario_id.value);
    if (usuario.value.con_entrevista_inicio && !usuario.value.entrevista_inicio_terminada) {
      // mostrarEntrevistaGlobal(usuario.value.entrevista_id);

    }
  }
});

onUnmounted(() => {
  if (usuario.value.id) {
    Echo.private(`usuario.${usuario.value.id}`)
      .stopListening('.paginas.descontadas')
      .stopListening('.paginas.agregadas');
  }

  Echo.leaveChannel('public');

})


</script>
